import { type ArtCatalog } from '../../pages/ArtCollection/ArtCollection.types'
import { type Artwork } from '../../types/art.types'
import { formatAnalyticsIndex } from './AnalyticsUtils'
import { type Tile } from '../../components/TilesProvider/TilesProvider.types'

export function getCatalogIndexProperties(
  catalog: ArtCatalog,
  categoryName?: string,
  artwork?: Artwork
): Record<string, unknown> {
  const props: Record<string, unknown> = {}

  if (categoryName) {
    const categoryIndex = Object.keys(catalog).indexOf(categoryName)
    props['Category Name'] = categoryName
    props['Category Index'] = formatAnalyticsIndex(categoryIndex)
  }

  if (artwork && categoryName) {
    const artworkIndex = catalog[categoryName].findIndex(
      (a) => a.uid === artwork.uid
    )
    props['Artwork Name'] = artwork.title
    props['Artwork Index'] = formatAnalyticsIndex(artworkIndex)
    props['Artwork UID'] = artwork.uid
    if (artwork.artworkSetNames) {
      props['Artwork Set Names'] = artwork.artworkSetNames
    }
  }

  return props
}

export function getFeedCategoriesProperties(
  catalog: ArtCatalog
): Record<string, unknown> {
  const categories = Object.keys(catalog)
  // Send first 10 categories in format - { 1: category1, 2: category2, ..., 10: category10 }
  const orderedCategories = categories.reduce(
    (previousValue, currentCategory, index: number) => {
      previousValue[index + 1] = currentCategory
      return previousValue
    },
    {} as Record<number, string>
  )
  return {
    'Featured Category': categories[0],
    'Categories Count': categories.length,
    Categories: categories,
    'Ordered Categories': {
      ...orderedCategories,
    },
  }
}

export function getTileArtworkProperties(tile: Tile) {
  const { artwork, addedFromCategory } = tile
  if (!artwork) return {}

  return {
    'Artwork Name': artwork.title,
    'Artwork UID': artwork.uid,
    'Artwork Artist Name': artwork.artist?.name,
    'Artwork Artist UID': artwork.artist?.uid,
    'Artwork Keywords': artwork.keywords,
    'Artwork Collections': artwork.collections,
    'Artwork Classifications': artwork.classifications.map(
      (classification) => classification.name
    ),
    ...(addedFromCategory ? { 'Category Name': addedFromCategory } : {}),
  }
}
